import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import { isIOS as f } from '../../utils/platform.js';

function p() {
  if (!f()) return {};
  var o;
  return {
    before: function before() {
      o = window.pageYOffset;
    },
    after: function after(_ref) {
      var r = _ref.doc,
          l = _ref.d,
          s = _ref.meta;

      function i(e) {
        return s.containers.flatMap(function (t) {
          return t();
        }).some(function (t) {
          return t.contains(e);
        });
      }

      l.style(r.body, "marginTop", "-".concat(o, "px")), window.scrollTo(0, 0);
      var n = null;
      l.addEventListener(r, "click", function (e) {
        if (e.target instanceof HTMLElement) try {
          var t = e.target.closest("a");
          if (!t) return;

          var _URL = new URL(t.href),
              c = _URL.hash,
              a = r.querySelector(c);

          a && !i(a) && (n = a);
        } catch (_unused) {}
      }, !0), l.addEventListener(r, "touchmove", function (e) {
        e.target instanceof HTMLElement && !i(e.target) && e.preventDefault();
      }, {
        passive: !1
      }), l.add(function () {
        window.scrollTo(0, window.pageYOffset + o), n && n.isConnected && (n.scrollIntoView({
          block: "nearest"
        }), n = null);
      });
    }
  };
}

export { p as handleIOSLocking };